import type { CloudOption } from '@labrav/react-components'

export const cloudOptions: CloudOption[] = [
  {
    name: 'AWS',
    disabled: false,
  },
  {
    name: 'GCP',
    disabled: false,
  },
  {
    name: 'AZURE',
    disabled: false,
  },
]
